import { filterFirmsByAragProvider } from './functions';

const providerIdOf = (firm) => (firm && firm.aragProvider ? firm.aragProvider.id : null);

// AC1: firms under the policy firm's provider; the policy's own provider is the fallback when that firm is not listed
export const transferFirmOptions = (lawsysFirms, currentFirmId, fallbackProviderId) => {
    const firms = lawsysFirms || [];
    const currentFirm = firms.find(f => f && f.id === currentFirmId);
    const providerId = providerIdOf(currentFirm) ?? fallbackProviderId ?? null;
    return filterFirmsByAragProvider(firms, providerId).map(f => ({ value: f.id, label: f.name, aragProvider: f.aragProvider }));
};
